import Header from "../../components/Header/Header";
import styles from "./Home.module.scss";
import backgroundImage from "../../assets/background.png";
import backgroundImageSmartphone from "../../assets/homesmartphone.jpg";
import salone2 from "../../assets/salone2.png";
import salone1 from "../../assets/salone1.png";
import salone3 from "../../assets/salone3.png";
import salone4 from "../../assets/salone4.jpeg";
import salone5 from "../../assets/salone5.jpeg";
import salone6 from "../../assets/salone6.jpeg";
import uomo1 from "../../assets/uomo1.jpeg";
import uomo2 from "../../assets/uomo2.jpeg";
import uomo3 from "../../assets/uomo3.jpeg";
import uomo4 from "../../assets/uomo4.jpeg";
import uomo5 from "../../assets/uomo5.jpeg";
import uomo6 from "../../assets/uomo6.jpeg";
import donna1 from "../../assets/donna1.jpeg";
import donna2 from "../../assets/donna2.jpeg";
import donna3 from "../../assets/donna3.jpeg";
import donna4 from "../../assets/donna4.jpeg";
import donna5 from "../../assets/donna5.jpeg";
import donna6 from "../../assets/donna6.jpeg";

import phoneIcon from "../../assets/phoneIcon.png";
import whatsappIcon from "../../assets/whatsappIcon.png";
import takara from "../../assets/takara.png";
import depotMale from "../../assets/depotmale.png";
import zoneconcept from "../../assets/zone-concept.png";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-regular-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import Maps from "../../components/Maps/Maps";
import Footer from "../../components/Footer/Footer";

const Home: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length); // Scorre di una sola immagine e loop infinito
  };

  useEffect(() => {
    const interval = setInterval(nextImage, 3000);
    return () => clearInterval(interval); // Pulizia dell'interval al momento della rimozione del componente
  }, []);

  const images = [salone6, salone5, salone4];
  const maleStyles = [uomo1, uomo2, uomo3, uomo4, uomo5, uomo6];
  const femaleStyles = [donna1, donna2, donna3, donna4, donna6];

  return (
    <>
      <div className="d-flex flex-column align-items-center justify-content-center overflow-hidden">
        <div className={`${styles.firstDiv} col-12`}>
          <img src={backgroundImage} className="d-md-block d-none" />
          <img src={backgroundImageSmartphone} className="d-md-none d-block " />

          <Header />
          {/*  POPUP ESTIVO */}

          {/* {popup && (
            <div className={`${styles.popUpContainer} d-flex flex-column  `}>
              <div className="d-flex flex-row align-items-center justify-content-end">
                <FontAwesomeIcon
                  icon={faXmark as IconProp}
                  onClick={dismissPopup}
                  className="cursor-pointer"
                />
              </div>
              <div className="d-flex flex-row align-items-center justify-content-center text-lato fw-bold">
                Attenzione!
              </div>
              <div className="d-flex flex-row align-items-center justify-content-center text-lato mt-4 text-center px-4">
                Da martedì 11 a sabato 22 Agosto saremo aperti solo la mattina, l'orario sarà il seguente:
              </div>
              <div className="d-flex flex-row align-items-center justify-content-center text-lato mt-4 text-center fw-bold ">
                9.00 - 13.00
              </div> */}
              {/* <div className="d-flex flex-row align-items-center justify-content-center text-lato mt-7 text-center fw-bold">
                I giorni 15 e 16 Agosto saremo chiusi.
              </div> */}
            {/* </div>
          )}  */}
          {/* POPUP IUNVERNALE */}

          {/* {popup && (
            <div className={`${styles.popUpContainer} d-flex flex-column  `}>
              <div className="d-flex flex-row align-items-center justify-content-end">
                <FontAwesomeIcon
                  icon={faXmark as IconProp}
                  onClick={dismissPopup}
                  className="cursor-pointer"
                />
              </div>
              <div className="d-flex flex-row align-items-center justify-content-center text-lato fw-bold">
                Attenzione!
              </div>
              <div className="d-flex flex-row align-items-center justify-content-center text-lato mt-4 text-center px-4">
                Gli orari durante le festività invernali saranno i seguenti:
              </div>
              <div className="col-md-12 col-12 p-4 p-md-0 d-flex flex-column align-items-center justify-content-center ">
                <span className="col-12 mt-3 d-flex flex-row  ">
                  <span className="col-md-4 col-5 fw-bold">Lunedì 22 </span>
                  <span className="col-md-8 col-7  ps-4">
                    09:00-13:00 &nbsp;&nbsp; 16:00-20:00
                  </span>
                </span>
                <span className="col-12 mt-3 d-flex flex-row ">
                  <span className="col-md-4 col-5  fw-bold">Martedi 23</span>
                  <span className="col-md-8 col-7  ps-4">
                    09:00-13:30 &nbsp;&nbsp; 16:00-20:00
                  </span>
                </span>
                <span className="col-12 mt-3 d-flex flex-row ">
                  <span className="col-md-4 col-5 fw-bold">Mercoledi 24</span>
                  <span className="col-md-8 col-7  ps-4">09:00-17:00</span>
                </span>
                <span className="col-12 mt-3 d-flex flex-row ">
                  <span className="col-md-4 col-5 fw-bold">Mercoledi 31</span>
                  <span className="col-md-8 col-7  ps-4">09:30-14:00</span>
                </span>
              </div>
              <div className="d-flex flex-row align-items-center justify-content-center text-lato mt-4 text-center  ">
                Il salone rimarrà&nbsp;<b>chiuso</b>&nbsp;nei seguenti
                giorni:&nbsp;
              </div>

              <div className="d-flex flex-row align-items-center justify-content-center text-lato  text-center ">
                <b>27 Dicembre</b>,&nbsp;<b>2</b>&nbsp;e&nbsp;<b>3</b>&nbsp;
                <b>Gennaio</b>
              </div>
              <div className="d-flex flex-row align-items-center justify-content-center text-lato mt-4 text-center fw-bold ">
                Riapriremo il 7 Gennaio.
              </div>

              <div className="d-flex flex-row align-items-center justify-content-center text-lato mt-4 text-center  ">
                <b>Buone Feste!</b>
              </div>
              <div className="d-flex flex-row align-items-center justify-content-center text-lato mt-1 text-center  ">
                <i>Mauro, Ornella e Luca</i>
              </div>
            </div>
          )} */}
          <div
            className={`d-flex flex-column align-items-center justify-content-center  color-white light-title-lato fw-bold ${styles.greatings}`}
          >
            Benvenuti nel
            <span className="title-lato fw-bold col-12 text-center mt-3">
              Salone Scavazzon
            </span>
            <span className="text-lato col-md-6 col-10 text-center mt-4">
              Il nostro salone è a conduzione familiare dal 1952, e attualmente
              è alla terza generazione. <br /> Passione e professionalità sono
              da sempre insiti nel nostro DNA da parrucchieri e possiamo offrire
              ai nostri clienti trattamenti e tagli all’ultima moda.
            </span>
            <div
              className={`d-flex flex-row col-5 align-items-center justify-content-center ${styles.buttonContainer} `}
            >
              <span
                className={`${styles.callBtn} text-tahoma d-flex flex-row align-items-center justify-content-center px-5 color-yellow fw-bold`}
              >
                <a
                  href={`tel:+393890304240`}
                  style={{ textDecoration: "none" }}
                  className=" col-12 color-white"
                >
                  Chiamaci
                </a>
              </span>
            </div>
          </div>
        </div>
        <div
          className={`${styles.pageDiv} py-5  col-12 d-flex flex-column align-items-center justify-content-start color-white light-title-tahoma fw-bold`}
        >
          <span> Il Salone</span>
          <div
            className={`d-flex flex-row align-items-center justify-content-start col-12 ${styles.imageScorrevole}`}
          >
            {images.map((image, index) => (
              <div key={index} className={`col-4 ${styles.imageContainer} `}>
                <img
                  src={image}
                  alt={`Slide ${index + 1}`}
                  //   style={{ width: "100%", height: "auto", objectFit: "cover" }}
                />
              </div>
            ))}
          </div>
        </div>
        <div
          className={`${styles.pageDiv} py-5 mt-10  col-12 d-flex flex-column align-items-center justify-content-start color-white light-title-tahoma fw-bold`}
        >
          <span> I nostri lavori</span>
          <div className={`${styles.container} d-md-flex d-none `}>
            {/* Prima riga (stili maschili) */}
            <div className={`${styles.row}`}>
              {maleStyles.map((image, index) => (
                <div key={index} className={`${styles.image_container}`}>
                  <img src={image} alt={`Male style ${index + 1}`} />
                </div>
              ))}
            </div>

            {/* Seconda riga (stili femminili) */}
            <div className={`${styles.row}`}>
              {femaleStyles.map((image, index) => (
                <div key={index} className={`${styles.image_container}`}>
                  <img src={image} alt={`Female style ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
          <div
            className={`d-flex d-md-none flex-column align-items-center justify-content-center  col-12 mt-7`}
          >
            <div
              className={`d-flex flex-row col-12 align-items-center justify-content-center mt-2 ${styles.rowWork}`}
            >
              <span className="col-3 h-100">
                <img src={donna6} className={`${styles.workImage}  col-2`} />
              </span>
              <span className="col-3 h-100">
                <img src={donna4} className={`${styles.workImage} col-2`} />
              </span>
              <span className="col-6 h-100">
                <img src={uomo6} className={`${styles.workImage} col-2`} />
              </span>
            </div>
            <div
              className={`d-flex flex-row col-12 align-items-center justify-content-center mt-2 ${styles.rowWork}`}
            >
              <span className="col-5 h-100">
                <img src={uomo5} className={`${styles.workImage} col-2`} />
              </span>
              <span className="col-4 h-100">
                <img src={donna2} className={`${styles.workImage}  col-2`} />
              </span>
              <span className="col-3 h-100">
                <img src={donna1} className={`${styles.workImage} col-2`} />
              </span>
            </div>
            <div
              className={`d-flex flex-row col-12 align-items-center justify-content-center mt-2 ${styles.rowWork}`}
            >
              <span className="col-3 h-100">
                <img src={uomo1} className={`${styles.workImage}  col-2`} />
              </span>
              <span className="col-6 h-100">
                <img src={uomo2} className={`${styles.workImage} col-2`} />
              </span>
              <span className="col-3 h-100">
                <img src={uomo3} className={`${styles.workImage} col-2`} />
              </span>
            </div>
          </div>
        </div>
        <div
          className={`${styles.pageDiv}  mb-10 mt-10  col-12 d-flex flex-column align-items-center justify-content-start color-white light-title-tahoma fw-bold`}
        >
          <span> Recensioni </span>
          <div className="col-12  d-flex flex-column align-items-center justify-content-start mt-10 text-tahoma">
            <div className="d-flex  flex-row align-items-center justify-content-around col-md-2 col-3 color-yellow px-md-5">
              <FontAwesomeIcon icon={faStar as IconProp} />
              <FontAwesomeIcon icon={faStar as IconProp} />
              <FontAwesomeIcon icon={faStar as IconProp} />
              <FontAwesomeIcon icon={faStar as IconProp} />
              <FontAwesomeIcon icon={faStar as IconProp} />
            </div>
            <div className="d-flex flex-row align-items-center justify-content-center col-md-8 col-11  mt-4 text-lato  text-center">
              Professionali, abili, qualificati, al passo con i tempi e molto
              simpatici. <br className="d-none d-md-flex" /> Mix perfetto per un
              servizio a 5 stelle sia per lui che per lei , ad un costo più che
              giusto. <br /> Grazie a Mauro Luca e Ornella.
            </div>
            <div className="d-flex flex-row align-items-center justify-content-center col-8  mt-4 text-tahoma fw-bold text-center">
              Andrea C.
            </div>

            <div className="d-flex flex-row align-items-center justify-content-around col-md-2 col-3 color-yellow px-md-5 mt-7">
              <FontAwesomeIcon icon={faStar as IconProp} />
              <FontAwesomeIcon icon={faStar as IconProp} />
              <FontAwesomeIcon icon={faStar as IconProp} />
              <FontAwesomeIcon icon={faStar as IconProp} />
              <FontAwesomeIcon icon={faStar as IconProp} />
            </div>
            <div className="d-flex flex-row align-items-center justify-content-center col-md-8 col-11  mt-4 text-lato  text-center">
              Storico salone uomo e donna di Voltabarozzo e uno degli ultimi
              barbieri rimasti nei dintorni. <br className="d-none d-md-flex" />{" "}
              Se avete una barba da tenere in ordine vale assolutamente la pena
              andare a trovare Mauro!
            </div>
            <div className="d-flex flex-row align-items-center justify-content-center col-8  mt-4 text-tahoma fw-bold text-center">
              Simone G.
            </div>

            <div className="d-flex flex-row align-items-center justify-content-around col-md-2 col-3 color-yellow px-md-5 mt-7">
              <FontAwesomeIcon icon={faStar as IconProp} />
              <FontAwesomeIcon icon={faStar as IconProp} />
              <FontAwesomeIcon icon={faStar as IconProp} />
              <FontAwesomeIcon icon={faStar as IconProp} />
              <FontAwesomeIcon icon={faStar as IconProp} />
            </div>
            <div className="d-flex flex-row align-items-center justify-content-center col-md-8 col-10  mt-4 text-lato  text-center">
              Oltre a essere molto bravi e competenti, sono anche gentilissimi!
              <br className="d-none d-md-flex" />
              Sono molto soddisfatta del taglio che mi ha fatto Luca!
            </div>
            <div className="d-flex flex-row align-items-center justify-content-center col-8  mt-4 text-tahoma fw-bold text-center">
              Bianca Elena B.
            </div>
          </div>
        </div>
        <div
          className={`${styles.pageDiv}  mt-10 mb-10 col-12 d-flex flex-column align-items-center justify-content-start color-white light-title-tahoma fw-bold`}
        >
          <span> I nostri partner </span>
          <div className="col-12 d-flex flex-column align-items-center justify-content-start mt-10 text-tahoma  mb-4 ">
            <span
              className={`${styles.partnerContainer} col-md-3 col-6 cursor-pointer`}
              onClick={() =>
                window.open(`https://www.takarabelmont.com/en/`, "_blank")
              }
            >
              <img src={takara} />
            </span>
          </div>
          <div className="col-12 d-flex flex-column align-items-center justify-content-start mt-md-5 text-tahoma  mb-4 ">
            <span
              className={`${styles.partnerContainer} col-md-3 col-6 cursor-pointer`}
              onClick={() =>
                window.open(`https://www.z-oneconcept.com/it/`, "_blank")
              }
            >
              <img src={zoneconcept} />
            </span>
          </div>
          <div className="col-12 d-flex flex-column align-items-center justify-content-start mt-md-5 text-tahoma  mb-4 ">
            <span
              className={`${styles.partnerContainer} col-md-3 col-6 cursor-pointer`}
              onClick={() =>
                window.open(`https://www.depotmaletools.com/it/`, "_blank")
              }
            >
              <img src={depotMale} />
            </span>
          </div>
        </div>
        <div
          className={`${styles.pageDiv}  mt-10 mb-10 col-12 d-flex flex-column align-items-center justify-content-start color-white light-title-tahoma fw-bold`}
        >
          <span> Contatti e Orari </span>
          <div className="col-12 d-flex flex-md-row flex-column  align-items-start justify-content-around mt-10 text-tahoma  mb-4  ">
            <div className="col-md-5 col-12 p-4 p-md-0 d-flex flex-column align-items-start justify-content-start ">
              <span className={` subtitle-tahoma fw-bold color-greyText`}>
                Orari di apertura
              </span>
              <span className="col-12 mt-5 d-flex flex-row  ">
                <span className="col-md-2 col-3 fw-bold">Lunedi</span>
                <span className="col-md-10 col-9  ps-4">Chiuso</span>
              </span>
              <span className="col-12 mt-3 d-flex flex-row ">
                <span className="col-md-2 col-3  fw-bold">Martedi</span>
                <span className="col-md-10 col-9  ps-4">
                  09:00-12:30 &nbsp;&nbsp; 16:00-20:00
                </span>
              </span>
              <span className="col-12 mt-3 d-flex flex-row ">
                <span className="col-md-2 col-3 fw-bold">Mercoledi</span>
                <span className="col-md-10 col-9  ps-4">
                  09:00-12:30 &nbsp;&nbsp; 16:00-20:00
                </span>
              </span>
              <span className="col-12 mt-3 d-flex flex-row ">
                <span className="col-md-2 col-3 fw-bold">Giovedi</span>
                <span className="col-md-10 col-9 ps-4">
                  09:00-12:30 &nbsp;&nbsp; 16:00-20:00
                </span>
              </span>
              <span className="col-12 mt-3 d-flex flex-row ">
                <span className="col-md-2 col-3  fw-bold">Venerdi</span>
                <span className="col-md-10 col-9 ps-4">
                  09:00-12:30 &nbsp;&nbsp; 16:00-20:00
                </span>
              </span>
              <span className="col-12 mt-3 d-flex flex-row ">
                <span className="col-md-2 col-3 fw-bold">Sabato</span>
                <span className="col-md-10 col-9 ps-4">
                  08:30-18:00 &nbsp;&nbsp; (Orario invernale)
                </span>
              </span>
              <span className="col-12 mt-3 d-flex flex-row ">
                <span className="col-md-2 col-3 fw-bold">Domenica</span>
                <span className="col-md-10 col-9 ps-4">Chiuso</span>
              </span>
              <div className=" subtitle-tahoma d-flex flex-row align-items-start justify-content-start fw-bold mt-6 color-greyText">
                Contattaci
              </div>
              <div className="d-flex flex-row align-items-start justify-content-start col-12  mt-5">
                <span
                  className={`${styles.contactBtn} d-flex flex-row align-items-center justify-content-center col-md-3 col-5 fw-bold`}
                >
                  <a
                    href={`tel:+393890304240`}
                    style={{ textDecoration: "none" }}
                    className=" col-12 color-white  h-100 d-flex flex-row align-items-center justify-content-center "
                  >
                    <span className="col-2  me-3">
                      <img src={phoneIcon} className={` ${styles.btnimg}`} />
                    </span>
                    <span>Telefono</span>
                  </a>
                </span>
                <span
                  className={`${styles.contactBtn} d-flex flex-row align-items-center justify-content-center col-md-3 col-5 fw-bold ms-5`}
                  onClick={() =>
                    window.open(`https://wa.me/+393890304240`, "_blank")
                  }
                >
                  <span className="col-2  me-3">
                    <img src={whatsappIcon} className={` ${styles.btnimg}`} />
                  </span>
                  <span>Whatsapp</span>
                </span>
              </div>
            </div>

            <div className="col-md-5 col-12 subtitle-tahoma  d-flex flex-column align-items-start justify-content-start fw-bold color-greyText p-4 p-md-0">
              Dove siamo
              <div className="col-12 " style={{ height: "350px" }}>
                <Maps />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
